import React from "react";
import Image1 from "../../../images/nashta1.jpg";
import EngagementSplitPage from "../../ui/EngagementSplitPage";

const Nashta = () => (
  <EngagementSplitPage title="Project Nashta" image={Image1} imageAlt="Project Nashta">
    <p>
      Kindness Unlimited has launched Project Nashta in April 2021 to address the nutrition needs of underprivileged children from Adivasi areas as well as the urban poor.
    </p>
    <p>
      During the ongoing Covid19 pandemic daily wage workers have lost jobs leaving many children extremely undernourished. Join us and be a part of this endeavor to reach out to vulnerable children.
    </p>
    <p>
      Kindness Unlimited is a 80G registered trust. Contributions can be made in Kind too please reach us at contactus@kindnessunlimited.in
    </p>
  </EngagementSplitPage>
);

export default Nashta;
